import { Autocomplete, FormControl, Skeleton } from '@mui/material';
import { styled } from '@mui/system';
import { MeasurementDate } from './types';

const elementWidth = 250;

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: elementWidth,
}));

export const StyledAutocomplete = styled(Autocomplete<MeasurementDate, false, true, false>)(({ theme }) => ({
  maxWidth: elementWidth,
  color: '#757575', // fallback grey
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.5)',
}));
